import { ALL_PERMISSIONS, type RoleListItem } from '#shared/types';
import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import { RoleBadge } from '#client/components/ui/StatusBadge';
import { RESOURCE } from '#client/lib/routes';
import { dash } from '#client/lib/format';

const columns: Column<RoleListItem>[] = [
  {
    key: 'name',
    header: 'Role',
    render: (row) => <RoleBadge role={row} />,
    width: '220px',
  },
  { key: 'description', header: 'What it is for', render: (row) => dash(row.description) },
  {
    key: 'permissions',
    header: 'Permissions',
    render: (row) =>
      row.is_super ? 'All' : `${row.permission_count} of ${ALL_PERMISSIONS.length}`,
    width: '130px',
  },
  {
    key: 'users',
    header: 'Staff',
    render: (row) => row.user_count,
    width: '80px',
  },
  {
    key: 'kind',
    header: '',
    render: (row) => (row.system_key ? <span className="c-perm-tag">Built-in</span> : null),
    width: '100px',
  },
];

export function RoleListPage() {
  return (
    <ResourceListPage<RoleListItem>
      title="Roles & permissions"
      subtitle="What each kind of staff member may see and do. Changes apply on their next click."
      path={RESOURCE.roles}
      columns={columns}
      noun="role"
      nounPlural="roles"
      searchPlaceholder="Search roles"
      rowLabel={(row) => row.name}
      createCapability="role.manage"
      editCapability="role.manage"
      deleteCapability="role.manage"
      // The server refuses both; offering the button would only earn a 4xx.
      canDeleteRow={(row) => row.system_key === null && row.user_count === 0}
      emptyBody="A role is a named set of permissions you give to staff."
    />
  );
}
